import { render, staticRenderFns } from "./NewsletterBlock.vue?vue&type=template&id=5d03f3d4&"
import script from "./NewsletterBlock.js?vue&type=script&lang=js&"
export * from "./NewsletterBlock.js?vue&type=script&lang=js&"
import style0 from "./NewsletterBlock.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports